import { CryptoError } from "./errors.js";
const CHARSETS = {
    lower: "abcdefghijkmnopqrstuvwxyz",
    upper: "ABCDEFGHJKLMNPQRSTUVWXYZ",
    digits: "23456789",
    symbols: "-_.:;!?@#$%^&*+="
};
export const DEFAULT_GEN_OPTIONS = {
    length: 20,
    sets: ["lower", "upper", "digits", "symbols"]
};
function randomBelow(bound) {
    if (!Number.isInteger(bound) || bound < 2 || bound > 256) {
        throw new CryptoError("invalid-input", "Bound must be an integer between 2 and 256.");
    }
    const limit = 256 - (256 % bound);
    const buf = new Uint8Array(1);
    for (;;) {
        crypto.getRandomValues(buf);
        const value = buf[0];
        if (value === undefined) {
            throw new CryptoError("invalid-input", "RNG returned no bytes.");
        }
        if (value < limit) {
            return value % bound;
        }
    }
}
function pickFrom(chars) {
    const idx = randomBelow(chars.length);
    const ch = chars[idx];
    if (ch === undefined) {
        throw new CryptoError("invalid-input", "Charset index out of range.");
    }
    return ch;
}
export function generatePassword(options = DEFAULT_GEN_OPTIONS) {
    if (!Number.isInteger(options.length) || options.length < 8 || options.length > 128) {
        throw new CryptoError("invalid-input", "Length must be an integer between 8 and 128.");
    }
    if (options.sets.length === 0 || options.sets.length > 4) {
        throw new CryptoError("invalid-input", "Select between 1 and 4 charsets.");
    }
    const unique = new Set(options.sets);
    if (unique.size !== options.sets.length) {
        throw new CryptoError("invalid-input", "Charsets must not repeat.");
    }
    if (options.length < unique.size) {
        throw new CryptoError("invalid-input", "Length must cover every selected charset.");
    }
    let pool = "";
    for (const set of unique) {
        const chars = CHARSETS[set];
        if (chars === undefined) {
            throw new CryptoError("invalid-input", "Unknown charset.");
        }
        pool += chars;
    }
    const out = [];
    for (const set of unique) {
        const chars = CHARSETS[set];
        if (chars === undefined) {
            throw new CryptoError("invalid-input", "Unknown charset.");
        }
        out.push(pickFrom(chars));
    }
    while (out.length < options.length) {
        out.push(pickFrom(pool));
    }
    for (let i = out.length - 1; i > 0; i -= 1) {
        const j = randomBelow(i + 1);
        const a = out[i];
        const b = out[j];
        if (a === undefined || b === undefined) {
            throw new CryptoError("invalid-input", "Shuffle index out of range.");
        }
        out[i] = b;
        out[j] = a;
    }
    return out.join("");
}
//# sourceMappingURL=generator.js.map